import { Toggle } from '../../base/Toggle';

export interface ConnectorCardProps {
  logoUrl: string;
  connectorName: string;
  connected: boolean;
  onToggle: () => void;
}

export function ConnectorCard({
  logoUrl,
  connectorName,
  connected,
  onToggle,
}: ConnectorCardProps) {
  return (
    <div className="bg-gray-100 dark:bg-gray-100/10 border border-gray-300 dark:border-gray-700 rounded-lg flex flex-col items-center justify-center pt-4 pb-4">
      <div className="w-full flex flex-row justify-stretch items-start">
        <img
          src={logoUrl}
          alt={`${connectorName} logo`}
          className="w-full -mr-14 mt-2 mb-4 h-24 object-contain"
        />
        <Toggle
          checked={connected}
          onChange={onToggle}
          className="mr-4 justify-self-end"
        />
      </div>
      <p className="text-base">{connectorName}</p>
    </div>
  );
}
